import { FC, useCallback } from 'react';

import { AnalyticsEventName } from '@/api/analytics';
import { ButtonSupport } from '@/components/buttons';
import { Intercom } from '@/hooks/3dParty/intercom';
import { useAnalytics } from '@/hooks/analytics';

interface SupportProps {
  eventName:
    | AnalyticsEventName.HEADER__BUTTONS__SUPPORT_BUTTON__CLICK
    | AnalyticsEventName.TABBAR__BUTTONS__SUPPORT_BUTTON__CLICK;
}

export const Support: FC<SupportProps> = ({ eventName }) => {
  const { sendEventToAnalytics } = useAnalytics();

  const handleButtonClick = useCallback(() => {
    sendEventToAnalytics({ name: eventName });

    Intercom.openChat();
  }, [eventName, sendEventToAnalytics]);

  return (
    <ButtonSupport id="intercomcustomLauncher" onClick={handleButtonClick} />
  );
};
